import { Link } from "react-router-dom";
import { Mail, Phone, ExternalLink } from "lucide-react";
import { InquiryCTA } from "./PlanEventModal";
import { CONTACT, NAV_LINKS } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black text-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-12 lg:py-20">
      <div className="lg:col-span-5">
        <img src="/images/logo-white.png" alt="Entertainment Nation" className="h-12 w-auto" />
        <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70">
          Entertainment Nation is powered by the team behind Trivia Nation, a live entertainment company built around one simple idea: people connect faster when they are playing, laughing, and competing together.
        </p>
        <a href={CONTACT.triviaNation} target="_blank" rel="noreferrer" data-testid="footer-trivia-nation-link" className="mt-5 inline-flex items-center gap-2 font-gothic uppercase tracking-wider text-sm text-en-teal hover:text-en-yellow transition-colors">
          Visit Trivia Nation <ExternalLink className="h-4 w-4" />
        </a>
      </div>

      <div className="lg:col-span-3">
        <p className="eyebrow mb-5">Menu</p>
        <ul className="space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-white/80 transition-colors hover:text-en-yellow">{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-4">
        <p className="eyebrow mb-5">Get in touch</p>
        <ul className="space-y-4">
          <li>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" data-track="email_click" className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-en-yellow break-all">
              <Mail className="h-4 w-4 shrink-0 text-en-teal" /> {CONTACT.email}
            </a>
          </li>
          <li>
            <a href={CONTACT.phoneHref} data-testid="footer-phone-link" data-track="phone_click" className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-en-yellow">
              <Phone className="h-4 w-4 shrink-0 text-en-teal" /> {CONTACT.phone}
            </a>
          </li>
        </ul>
        <InquiryCTA label="Get Started" data-testid="footer-plan-event-btn" className="btn-primary mt-8" />
        <p className="mt-8 text-xs leading-relaxed text-white/50">
          Bar or restaurant interested in hosting trivia or games?{" "}
          <a href={CONTACT.triviaNationBars} target="_blank" rel="noreferrer" data-testid="footer-bars-link" className="underline hover:text-en-yellow">Visit Trivia Nation for venues</a>.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 bg-black">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© {new Date().getFullYear()} Entertainment Nation. All Rights Reserved.</span>
        <span className="font-gothic uppercase tracking-wider">{CONTACT.email} &nbsp;|&nbsp; {CONTACT.phone} &nbsp;|&nbsp; <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-en-yellow">Privacy & analytics preferences</Link> &nbsp;|&nbsp; <Link to="/admin" data-testid="footer-admin-link" className="hover:text-en-yellow">Admin</Link></span>
      </div>
    </div>
  </footer>
);
